import { styled } from 'solid-styled-components';
import { ErrorIcon } from 'src/app/components';

export const ErrorIconStyled = styled(ErrorIcon)`
    margin-top: 2px;
`;
